// Ella Rue header — mobile menu toggle.
// Follows Dawn's custom element pattern (cf. cart-drawer.js, product-form.js).
class EllaHeader extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('.ella-header__toggle');
    this.nav = this.querySelector('.ella-header__nav');
  }

  connectedCallback() {
    if (!this.toggle) return;
    this.toggle.addEventListener('click', this.onToggle.bind(this));
    this.markActiveLink();
  }

  // Liquid link.active doesn't resolve in local dev (domain mismatch).
  // This compares pathnames client-side as a reliable fallback.
  markActiveLink() {
    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    this.querySelectorAll('.ella-header__menu-link').forEach(el => {
      try {
        const linkPath = new URL(el.href).pathname.replace(/\/$/, '') || '/';
        if (linkPath === currentPath) {
          el.classList.add('ella-header__menu-link--active');
        }
      } catch (_) {}
    });
  }

  onToggle() {
    const isOpen = this.hasAttribute('open');
    if (isOpen) {
      this.removeAttribute('open');
    } else {
      this.setAttribute('open', '');
    }
    this.toggle.setAttribute('aria-expanded', String(!isOpen));
  }
}

customElements.define('ella-header', EllaHeader);
